import { ISelectOption } from '../../ui-toolkit';

export enum eManualCheckDisbursementCategory {
  commission = 'commission',
  due_to_borrower = 'due_to_borrower',
  due_to_seller = 'due_to_seller',
  hoa = 'hoa',
  holdback_utilities = 'holdback_utilities',
  holdback_repairs = 'holdback_repairs',
  holdback_post_closing_occupancy = 'holdback_post_closing_occupancy',
  home_owners_insurance = 'home_owners_insurance',
  home_warranty = 'home_warranty',
  inspection = 'inspection',
  other = 'other',
  payoff = 'payoff',
  proceeds = 'proceeds',
  property_taxes = 'property_taxes',
  recording = 'recording',
  recording_refund = 'recording_refund',
  refund = 'refund',
  remittance = 'remittance',
  security_deposit = 'security_deposit',
  taxes = 'taxes',
  title = 'title',
  utilities = 'utilities',
  workshare = 'workshare',
}

export const prettyManualCheckDisbursementCategory: Record<eManualCheckDisbursementCategory, string> = {
  commission: 'Commission',
  due_to_borrower: 'Due to Borrower',
  due_to_seller: 'Due to Seller',
  hoa: 'Hoa',
  holdback_utilities: 'Holdback Utilities',
  holdback_repairs: 'Holdback Repairs',
  holdback_post_closing_occupancy: 'Holdback Post Closing Occupancy',
  home_owners_insurance: 'Home Owners_insurance',
  home_warranty: 'Home Warranty',
  inspection: 'Inspection',
  other: 'Other',
  payoff: 'Payoff',
  proceeds: 'Proceeds',
  property_taxes: 'property Taxes',
  recording: 'Recording',
  recording_refund: 'Recording Refund',
  refund: 'Refund',
  remittance: 'Remittance',
  security_deposit: 'Security Deposit',
  taxes: 'Taxes',
  title: 'Title',
  utilities: 'Utilities',
  workshare: 'Workshare',
};

export const manualCheckDisbursementCategoryOptions: ISelectOption[] = Object.values(
  eManualCheckDisbursementCategory
).map((manualCheckCategory) => ({
  label: prettyManualCheckDisbursementCategory[manualCheckCategory],
  value: manualCheckCategory,
}));
